import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function PillarArticlesSection() {
  const { t, i18n } = useTranslation();
  const lang = ["en", "pl", "es", "fr"].includes(i18n.language) ? i18n.language : "en";

  return (
    <section id="guides" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
            {t("guides.badge")}
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("guides.title")}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("guides.subtitle")}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((a) => {
            const c = a.content[lang] || a.content.en;
            return (
              <Link
                key={a.slug}
                to={`/${a.slug}`}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
              >
                <div className="relative h-44 w-full overflow-hidden">
                  <img
                    src={a.image}
                    alt={c.title}
                    title={`${c.title} — USFans Spreadsheet`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center gap-2">
                    <span className="inline-block rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-semibold text-secondary-900">
                      {c.category}
                    </span>
                    <span className="text-xs text-foreground-500">{c.readingTime}</span>
                  </div>
                  <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 group-hover:text-primary-800">
                    {c.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {c.subtitle}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700">
                    {t("guides.readMore")}
                    <span className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-0.5">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}